"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rethrowApiError = exports.isApiError = exports.isNetworkError = void 0;
const axios_1 = require("axios");
class NetworkError extends Error {}
class ApiError extends Error {
  constructor(response) {
    super();
    this._data = response;
  }
  get data() {
    return this._data;
  }
}
function isNetworkError(error) {
  return error instanceof NetworkError;
}
exports.isNetworkError = isNetworkError;
function isApiError(error) {
  return error instanceof ApiError;
}
exports.isApiError = isApiError;
function rethrowApiError(error) {
  if (axios_1.default.isAxiosError(error)) {
    if (!error.response) {
      throw new NetworkError();
    } else {
      throw new ApiError(error.response);
    }
  } else {
    throw error;
  }
}
exports.rethrowApiError = rethrowApiError;